/* ------------------------------------------------------------ */
/* -- Google Tag Datalayer -- */
/* ------------------------------------------------------------ */
export const gtagDataLayer = () => {
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', 'G-2MSGZCHK2Z');
};
